// extracted by mini-css-extract-plugin
export default {"componentWrapper":"Homepage_componentWrapper__7vUnR"};